import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import LoginComponent from './UserLogin';
import CreateAction from '../components/operational/createAction';
import myUserSlice from '../redux/myUserSlice';
import MobligoLogo from '../assets/img/mobligo_new.png';
const Login = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    if (token && refreshToken) {
      checkAuth();
      return;
    }
    localStorage.clear();
  }, []);

  const checkAuth = async () => {
    const response = await CreateAction({
      method: 'get',
      path: '/profile',
      showPreLoader: false,
      isFileUploading: false,
    });
    if (response?.error) return localStorage.clear();
    const user = response.result.resultData;
    dispatch(myUserSlice.actions.setUser(user));
    window.location.href = '/chooseApp';
  };

  return (
    <div className="authPage d-flex overflow-auto">
      <div className="login bg-[#ffffff] h-[100vh] overflow:hidden flex justify-center">
        <div className="relative flex flex-row flex-wrap items-center justify-center h-[100%]">
          <div className="z-[1000] w-[300px] sm:w-[500px] bg-[#FFFFFF] rounded-xl">
            <div className="flex flex-col justify-center  items-center gap-3 h-max">
              <a className="w-full flex items-center justify-center" href="https://www.mobligo.com">
                <img className="w-[70%] xl:w-[43%] lg:w-[43%] mt-5" src={MobligoLogo} alt="" />
              </a>
              <LoginComponent />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
